export var getEvaluationObject = function getEvaluationObject(makeObj) {
  var make = makeObj.make,
    displayValue = makeObj['make-displayValue'];
  return {
    year: '',
    'year-displayValue': '',
    model: '',
    'model-displayValue': '',
    variant: '',
    'variant-displayValue': '',
    make: make,
    'make-displayValue': displayValue,
    registeredState: '',
    'registeredState-displayValue': '',
    first_owner: '',
    'first_owner-displayValue': '',
    mileage: '',
    'mileage-displayValue': '',
    phone: '',
    'phone-displayValue': '',
    transmission: '',
    'transmission-displayValue': '',
    bodyType: '',
    'bodyType-displayValue': '',
    facelift: '',
    'faceLift-displayValue': '',
    seat: '',
    'seat-displayValue': '',
    engine: '',
    'engine-displayValue': '',
    wheelDrive: '',
    'wheelDrive-displayValue': '',
    sellingUrgency: '',
    'sellingUrgency-displayValue': ''
  };
};